import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Renders a Link component by passing the state defined props to the appropriate slots.
 */
export const renderLink_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsx(state.root, {});
};